// extracted by mini-css-extract-plugin
module.exports = {"expertsIntroductionContainer":"pages-experts-experts__expertsIntroductionContainer--1_LKS"};